/**
 * Banner messages are data, not markup. Text is rendered as text, and the only
 * rich element a banner can contain is a single link, described by `action`.
 * Nothing a banner shows can introduce HTML into the page.
 */
export interface AppMessage {
  text: string;
  action?: {
    label: string;
    href: string;
  };
}

export function toAppMessage(message: string | AppMessage): AppMessage {
  return typeof message === 'string' ? { text: message } : message;
}
